import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { task, timeout } from 'ember-concurrency';
import { action } from '@ember/object';
import { isoDate } from '@dubbletrack/time/helpers/iso-date';
import _ from 'lodash';
import { tracked } from '@glimmer/tracking';
import { next } from '@ember/runloop';
export default class DeluxePlayerScheduleComponent extends Component {
  @service store;
  @service settings;
  @service socket;
  @service intl;
  @service clock;
  @service dataStore;
  @service scheduleDataStore;

  @tracked firstVisibleTime;
  @tracked firstVisibleIndex;
  @tracked firstItemToday;
  @tracked lastVisibleIndex;
  @tracked lastVisibleTime;
  @tracked element;

  jumpToDateTask = task({ restartable: true, maxConcurrency: 1 }, async dateObject => {
    if (this.element) {
      let count = 0;
      let iso = isoDate(dateObject.date, { dateOnly: true });
      let foundElement;
      while (!foundElement) {
        var allVisibleDays = [...this.element.querySelectorAll(
          `.dubbletrack-mini-schedule-day[data-date]`,
        )].map(el => el.getAttribute('data-date'))
        var sortedDays = _.uniq([...allVisibleDays, iso]).sort()
        let index = _.findIndex(sortedDays, (item) => item == iso)
        foundElement = this.element.querySelector(
          `.dubbletrack-mini-schedule-day[data-date="${iso}"]`,
        );
        if (foundElement) {
          break;
        }

        if (index === 0) {  // scroll up
          // console.log(`scroll up looking for ${iso}`, sortedDays, index)
          this.element.parentElement.scrollTo({
            top: this.element.parentElement.scrollTop - 600,
            behavior: "instant"
          });
          // yield timeout(10);
        } else if (index == (sortedDays.length - 1)) { // scroll down
          // console.log(`scroll down looking for ${iso}`, sortedDays, index)
          this.element.parentElement.scrollTo({
            top: this.element.parentElement.scrollTop + 600,
            behavior: "instant"
          });
          // yield timeout(10);
        } else {
          // console.log(`found `, foundElement)
        }
        await timeout(10);
        count = count + 1;

        if (count > 50) {
          break;
        }
      }

      await timeout(40);

      if (foundElement) {
        foundElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }
  });

  @action
  didInsert(element) {
    this.element = element;

    if (this.scheduleDataStore.currentItem?.isLoaded) {
      this.scrollIntoView('instant');
    } else {
      this.scheduleDataStore.loadAiringsFromDateTask.perform(this.scheduleDataStore.currentItem).then(() => {
        this.scrollIntoView('smooth')
      });
    }
  }

  @action 
  scrollIntoView(behavior = 'smooth') {
    next(() => {
      let currentFeed = this.element.querySelector('.dubbletrack-schedule-item.is-current-feed')
      if (currentFeed) {
        currentFeed.scrollIntoView({behavior: behavior, block: 'center'})
      } else {
        this.jumpToDateTask.perform(this.scheduleDataStore.currentItem)
      }
    })
  }

  @action
  firstVisibleChanged(item, index) {
    this.currentIndex = Math.min(index + 1, this.scheduleDataStore.dateObjects.length - 1);
    this.scheduleDataStore.currentItem = this.scheduleDataStore.dateObjects[this.currentIndex];
  }

  @action
  lastVisibleChanged(item, index) {
    // this.selectedDate = item?.date;
    this.lastVisibleIndex = index;
  }
}
